import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const WechatThrough = () => {
  const searchParams = useLocation().search;
  const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');

  useEffect(() => {
    if (paramPayUrl) {
      window.location.replace(decodeURIComponent(paramPayUrl));
    }
  }, []);

  return (
    <div style={{ textAlign: 'center', paddingTop: 20 }}>
      Payment in Process...
    </div>
  );
};

export default WechatThrough;
